import { z } from 'zod';
export const portalOtpRequestSchema = z.object({
    phone: z.string().trim().min(7).max(20),
});
export const portalOtpVerifySchema = z.object({
    phone: z.string().trim().min(7).max(20),
    code: z.string().trim().regex(/^\d{6}$/),
    patientId: z.string().uuid().optional(),
    dateOfBirth: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD').optional(),
    mrn: z.string().trim().max(40).optional(),
});
export const portalBookingSchema = z.object({
    doctorId: z.string().uuid(),
    branchId: z.string().uuid().optional(),
    slotAt: z.string().datetime(),
    reason: z.string().trim().max(400).optional(),
});
/** Kiosk check-in: the patient identifies themselves, nothing more (SRS 11.2). */
export const kioskCheckInSchema = z.object({
    /** MRN, phone or the QR payload printed on the appointment slip. */
    identifier: z.string().trim().min(3).max(60),
    branchId: z.string().uuid().optional(),
    dateOfBirth: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD').optional(),
    mrn: z.string().trim().max(40).optional(),
});
export const referralSchema = z.object({
    patientId: z.string().uuid(),
    referrerUserId: z.string().uuid(),
    reason: z.string().trim().max(600).optional(),
    /** Commission percentage where the tenant has configured one (SRS 11.3). */
    commissionPct: z.number().min(0).max(100).default(0),
});
export const PORTAL_DOCUMENT_KINDS = ['prescription', 'invoice', 'certificate', 'lab', 'radiology'];
export const portalDocumentQuerySchema = z.object({
    format: z.enum(['html', 'pdf']).default('html'),
    lang: z.enum(['en', 'ar', 'both']).optional(),
});
export const portalAvailabilityQuerySchema = z.object({
    doctorId: z.string().uuid(),
    from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD'),
    days: z.coerce.number().int().min(1).max(14).default(7),
});
//# sourceMappingURL=portal.js.map